import React from 'react'
import { BrowserRouter as Router, Switch, Route,Redirect } from 'react-router-dom'
import Main from './pages/main'
import Password from './pages/password/password'
import LoginForm from './pages/signin/signin'
import ForgotPassword from './pages/signin/forgot.password'
// import Customers from './pages/customers/customers';
// import { PrivateRoute }         from './component';
import { constants } from './constants'
import Surgeon from './pages/surgeon/surgeon'
import { ActivityView, DeviceMeasurementView } from './pages/activities'
import Otpverification from './pages/signin/otpverification'
import PatientRegistration from './pages/patient_registeration/registration'
import PatientDelete from './pages/patient/patient.delete'


var { ROLE } = constants

const Routes = (props) => {
  return (
    <Router>
      {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
      <Switch>
        <Route path='/account/delete'>
          <PatientDelete />
        </Route>
        <Route path='/auth/:customer_id'>
          <PatientRegistration />
        </Route>
        <Route path='/login'>
          <LoginForm />
        </Route>

        <Route path='/forgot-password'>
          <ForgotPassword />
        </Route>

        <Route path='/two-step-verification'>
          <Otpverification />
        </Route>

        <Route path={['/set-password/:token', '/reset-password/:token']}>
          <Password />
        </Route>

        {/* <PrivateRoute path="/customers" roles={[ROLE.COMPANY_ADMIN, ROLE.SUPER_ADMIN]} exact component={Customers} /> */}

        <Route exact path={['/surgeon/:id', '/surgeon/:id/patient/:patientid']}>
          <Surgeon />
        </Route>
        <Route
          exact
          path={['/activity/:token/:patientid', '/activity/:patientid']}
        >
          <ActivityView />
        </Route>

        <Route exact path={['/measurement/device/:token/:patientid/:deviceid']}>
          <DeviceMeasurementView />
        </Route>

        <Route
          exact
          path="/"
          render={({ location }) => {
            const searchParams = new URLSearchParams(location.search);
            const appParam = searchParams.get('app');
            return appParam === 'admin-lite' ? <LoginForm /> : <Redirect to="/login" />;
          }}
        />
       

        <Route path='*'>
          <Main />
        </Route>
      </Switch>
    </Router>
  )
}

export default Routes
